import CreateRoomConferenceHeader from './components/CreateRoomConferenceHeader';
import CreateRoomConferenceForm from './components/CreateRoomConferenceForm';

export default function CreateRoomConference() {
  return (
    <div className="container-96 pt-10">
      <CreateRoomConferenceHeader />
      <CreateRoomConferenceForm />
    </div>
  );
}
